import React from 'react'
import Layout from '../components/layout'
import SEO from '../components/seo'
import colours from '../lib/colours'
import styled from 'styled-components'
import IEventedComponent from '../components/IEventedComponent'

const StyledWrapper = styled.div`
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  background-color: ${colours.darkPurple} !important;
  word-break: break-word;
  flex: 1;
`

interface IProps {}

interface IState {}

class IndexPageLayout extends IEventedComponent<IProps, IState> {
  render() {
    return (
      <StyledWrapper>
        <Layout>
          <SEO title="Home" description="MSA Levy Estimator" />
          {this.props.children}
        </Layout>
      </StyledWrapper>
    )
  }
}

export default IndexPageLayout
